import { isSamePage } from '~/src/common/utils/url';
import constants from '~/src/constants';

const isInternal = (url: string) =>
  new RegExp(`^(https?:\\/\\/)?www.(dev\\.|staging\\.)?${constants.baseDomainUrl}.*`).test(url);

export const getLinkProps = (url: string) => {
  if (isInternal(url)) {
    const { pathname, search, hash } = new URL(url);
    return {
      href: pathname + search + hash,
      shallow: !isSamePage(pathname, url),
      target: '_self',
    };
  }
  return { href: url, shallow: false, target: '_blank' };
};
